import { SsuHud } from '@capsicum/common-web';
import { useSsuBalance } from '@capsicum/features/wallet/shared';

type SsuBalanceProps = {
	testID?: string;
};

export const SsuBalance = ({ testID = 'top-bar-ssu-hud' }: SsuBalanceProps) => {
	const balance = useSsuBalance();

	return (
		<SsuHud size="small" testID={testID}>
			{balance}
		</SsuHud>
	);
};
